import { render } from "./News.vue?vue&type=template&id=4fe13a23&scoped=true"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"

import "./News.vue?vue&type=style&index=0&id=4fe13a23&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4fe13a23"

export default script